import { MediaContentType } from '../types/graphql.js'
import { getVariantMediaList } from '../utils/helper.js'
import type { Replace } from '../types/type-helper'
import type { Product, ProductMedia, ProductVariant } from '../types/product'
import { useEffect, useState } from 'react'

export type ImageMedia = Replace<ProductMedia, 'mediaContentType', MediaContentType.Image>
export type VideoMedia = Replace<ProductMedia, 'mediaContentType', MediaContentType.Video>

export function useVariantMedia({ product, variant }: { product: Product; variant: ProductVariant }): {
  productList: ImageMedia[]
  sceneList: ImageMedia[]
  keyFeaturesList: ImageMedia[]
  videoList: VideoMedia[]
} {
  const mediaList = product?.media?.filter(media => media.mediaContentType === MediaContentType.Image)
  const productImageList = [mediaList?.[0]] as ImageMedia[]
  const scenes = mediaList?.slice(1, productImageList.length) as ImageMedia[]
  const keyFeatures = mediaList?.slice(2, productImageList.length) as ImageMedia[]
  const videos = product?.media?.filter(media => media.mediaContentType === MediaContentType.Video) as VideoMedia[]
  const [imageList, setImageList] = useState<ImageMedia[]>(productImageList || [])
  const [sceneList, setSeneList] = useState<ImageMedia[]>(scenes || [])
  const [videoList, setVideoList] = useState<VideoMedia[]>(videos || [])
  const [keyFeaturesList, setKeyFeaturesList] = useState<ImageMedia[]>(keyFeatures || [])
  useEffect(() => {
    const mediaList = getVariantMediaList({ product, variant })

    const imageList = mediaList?.filter(media => media.mediaContentType === MediaContentType.Image) as ImageMedia[]
    setImageList(imageList?.[0] ? [imageList[0]] : [])
    setSeneList(imageList?.slice(1, imageList?.length) || [])
    setKeyFeaturesList([])
    setVideoList((mediaList?.filter(media => media.mediaContentType === MediaContentType.Video) as VideoMedia[]) || [])
  }, [product, variant])

  return { productList: imageList, sceneList, videoList: videoList, keyFeaturesList }
}
